<script lang="ts">
    import { createModal } from '$components/Modal.svelte';
    import { melt } from '@melt-ui/svelte';
    import ModalGoafricaContact from '$components/GoafricaContact/ModalGoafricaContact.svelte';
    import { createForm } from '$components/GoafricaContact/GoafricaContactFormData';
    import uniqueId from 'lodash/uniqueId';
    import type { CurrentUser_MeFragment } from '$gql/graphql';

    let className = '';
    export { className as class };

    export let href: string | null = null;
    export let text: string | null = null;
    export let icon: string | null = 'fa fa-phone';
    export let subject: string | null = null;
    export let to: string | null = null;
    export let withCompanyNameRequired: boolean = false;
    export let withPhoneRequired: boolean = false;
    export let messagePlaceholder: string | null = null;
    export let modalTitle: string | null = null;
    export let currentUser: CurrentUser_MeFragment | null;
    export let defaultRelatedCategoryId: number | null = null;

    const [form, fields] = createForm(
        `${uniqueId('goafrica-contact-')}`,
        {
            subject,
            to,
            email: currentUser?.email ?? null,
            lastname: currentUser?.lastname ?? null,
            firstname: currentUser?.firstname ?? null,
            phone: currentUser?.firstPhoneNumber ?? null,
            relatedCategoryId: defaultRelatedCategoryId,
        },
        {
            withCompanyNameRequired,
            withPhoneRequired,
            withSubject: false,
        },
    );
    const prefixId = uniqueId('p');

    const modal = createModal({});
    const {
        states: { open },
        elements: { trigger },
    } = modal;

    function onSuccess() {
        $open = false;
        form.dispatch((_state) => form.getInitialState());
    }
</script>

{#if href != null}
    <a class={className} {href} data-sveltekit-reload={true}>
        {#if icon != null}
            <i class={`${icon} mr-2`} aria-hidden="true"></i>
        {/if}
        {text}
    </a>
{:else}
    <button class={className} use:melt={$trigger}>
        {#if icon != null}
            <i class={`${icon} mr-2`} aria-hidden="true"></i>
        {/if}
        {text}
    </button>
    <ModalGoafricaContact
        {form}
        {fields}
        {prefixId}
        {modal}
        {modalTitle}
        {currentUser}
        {withCompanyNameRequired}
        {withPhoneRequired}
        {messagePlaceholder}
        {onSuccess}
    />
{/if}
